"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearPostData = exports.clearPostFailureErrors = exports.setPostFailureErrors = exports.fetchUpdatePostEntityFailure = exports.fetchUpdatePostEntitySuccess = exports.fetchUpdatePostEntity = exports.setPostEntityMetas = exports.fetchPostEntityFailure = exports.fetchPostEntitySuccess = exports.fetchPostEntity = exports.uploadEntityMediaPlanSuccess = exports.toggleBookmarked = exports.removeApartmentFailure = exports.removeApartmentSuccess = exports.removingApartment = exports.duplicateApartmentFailure = exports.duplicateApartmentSuccess = exports.duplicatingApartment = exports.uploadApartmentImagesSuccess = exports.uploadImagesFailure = exports.uploadBuildingImagesSuccess = exports.uploadingImages = exports.addingPostViewFailure = exports.fetchPostFailure = exports.fetchPostSuccess = exports.fetchingPost = exports.createPostFailure = exports.createPostSuccess = exports.creatingPost = exports.getTranslatedText = exports.updateEntity = exports.getPostEntity = exports.publishPost = exports.removeApartment = exports.duplicateApartment = exports.addEmptyApartment = exports.reorderApartmentMedia = exports.removeEntityPlanMediaById = exports.removeEntityMediaByID = exports.uploadEntityPlanMediaById = exports.uploadApartmentMedia = exports.reorderBuildingMedia = exports.removeParentEntityMediaById = exports.uploadBuildingMedia = exports.addView = exports.updatePost = exports.createPost = exports.getPostBySlug = exports.getMyAnnouncementPost = exports.getPost = void 0;
exports.selectDeveloperMedia = exports.selectPersonalMedia = exports.selectUpdatePostFailureErrors = exports.selectSinglePost = exports.selectInitialValues = exports.composeSingleSectionInitialValues = exports.selectIsTranslating = exports.selectCurrentPost = exports.selectPost = exports.selectTranslationSender = exports.selectPostLoading = exports.selectHasPermission = exports.selectUpdateApartmentSuccess = exports.selectUpdateApartmentLoading = exports.selectLoading = exports.translationComplete = exports.translationStart = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = __importDefault(require("lodash"));
var GeneralSettings_1 = require("../../constants/GeneralSettings");
var schemaHelper_1 = require("../../helpers/schemaHelper");
var schemaSlice_1 = require("./schemaSlice");
var strings_1 = require("../../helpers/strings");
var initialState = {
    post: undefined,
    error: undefined,
    viewAdded: false,
    loading: false,
    sectionsLoading: true,
    apartmentLoading: true,
    updateApartmentSuccess: false,
    updateApartmentLoading: false,
    updatePostFailureErrors: [],
    isTranslating: false,
    translationSender: null,
};
var postSlice = toolkit_1.createSlice({
    name: 'post',
    initialState: initialState,
    reducers: {
        creatingPost: function (state) {
            state.loading = true;
        },
        createPostSuccess: function (state, action) {
            state.loading = false;
            state.post = action.payload.post;
        },
        createPostFailure: function (state) {
            state.loading = false;
        },
        setPostFailureErrors: function (state, action) {
            var errors = strings_1.isApartmentsInfoErrors(action.payload.response.data.errors);
            if (errors) {
                state.updatePostFailureErrors = errors;
            }
        },
        clearPostFailureErrors: function (state) {
            state.updatePostFailureErrors = [];
        },
        fetchingPost: function (state) {
            state.loading = true;
        },
        fetchPostSuccess: function (state, action) {
            state.loading = false;
            state.post = action.payload.post;
        },
        fetchPostFailure: function (state) {
            state.loading = false;
        },
        clearPostData: function (state) {
            state.post = undefined;
        },
        uploadingImages: function (state) {
            state.loading = true;
        },
        uploadBuildingImagesSuccess: function (state, action) {
            state.loading = false;
            if (action.payload) {
                state.post.sections.about_building.media = action.payload.media;
            }
        },
        uploadImagesFailure: function (state) {
            state.loading = false;
        },
        uploadApartmentImagesSuccess: function (state, action) {
            state.loading = false;
            state.post.sections.apartment_info =
                state.post.sections.apartment_info.map(function (a) {
                    if (action.payload.id !== a.entity_id) {
                        return a;
                    }
                    return __assign(__assign({}, a), { media: action.payload.media });
                });
        },
        toggleBookmarked: function (state) {
            state.post.bookmarked = !state.post.bookmarked;
        },
        addingPostViewFailure: function (state, action) {
            state.loading = false;
            state.error = action.payload.errors;
        },
        duplicatingApartment: function (state) {
            state.loading = true;
            state.error = undefined;
        },
        duplicateApartmentSuccess: function (state, action) {
            state.loading = false;
            state.post.sections.apartment_info.push(action.payload);
        },
        duplicateApartmentFailure: function (state) {
            state.loading = false;
        },
        removingApartment: function (state) {
            state.loading = true;
            state.error = undefined;
        },
        removeApartmentSuccess: function (state, action) {
            state.loading = false;
            state.post.sections.apartment_info =
                state.post.sections.apartment_info.filter(function (apt) { return apt.entity_id !== action.payload; });
        },
        removeApartmentFailure: function (state) {
            state.loading = false;
        },
        translationStart: function (state, action) {
            state.loading = true;
            state.isTranslating = true;
            state.translationSender = action.payload;
        },
        translationComplete: function (state) {
            state.loading = false;
            state.isTranslating = false;
            state.translationSender = null;
        },
        uploadEntityMediaPlanSuccess: function (state, action) {
            var _a;
            state.loading = false;
            var mapping = (_a = {},
                _a[GeneralSettings_1.MEDIA_TYPES.FLOOR_PLAN] = 'floor_plan',
                _a[GeneralSettings_1.MEDIA_TYPES.APARTMENT_PLAN] = 'apartment_plan',
                _a[GeneralSettings_1.MEDIA_TYPES.BUILDING_PLAN] = 'building_plan',
                _a);
            state.post.sections.apartment_info =
                state.post.sections.apartment_info.map(function (a) {
                    var _a;
                    if (action.payload.id !== a.entity_id) {
                        return a;
                    }
                    return __assign(__assign({}, a), (_a = {}, _a[mapping[action.payload.type]] = null, _a));
                });
        },
        fetchPostEntity: function (state) {
            state.apartmentLoading = true;
        },
        setPostEntityMetas: function (state, action) {
            state.post.sections.apartment_info.filter(function (apartment, index) {
                if (apartment.id === action.payload.entities.id) {
                    state.post.sections.apartment_info[index] =
                        action.payload.entities;
                }
            });
        },
        fetchPostEntitySuccess: function (state) {
            state.apartmentLoading = false;
        },
        fetchPostEntityFailure: function (state) {
            state.apartmentLoading = true;
        },
        fetchUpdatePostEntity: function (state) {
            state.updateApartmentSuccess = false;
            state.updateApartmentLoading = true;
        },
        fetchUpdatePostEntitySuccess: function (state) {
            state.updateApartmentSuccess = true;
            state.updateApartmentLoading = false;
        },
        fetchUpdatePostEntityFailure: function (state) {
            state.updateApartmentSuccess = false;
            state.updateApartmentLoading = false;
        },
    },
});
//@TODO need to post strict return type for this function
var getPost = function (id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchingPost());
                    return [4 /*yield*/, axios_1.default.get("/api/post/" + id, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.fetchPostSuccess(data));
                    return [2 /*return*/, data];
                case 2:
                    e_1 = _a.sent();
                    dispatch(exports.fetchPostFailure());
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getPost = getPost;
var getMyAnnouncementPost = function (id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchingPost());
                    return [4 /*yield*/, axios_1.default.get("/api/post/my-announcement/" + id)];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.fetchPostSuccess(data));
                    return [2 /*return*/, data];
                case 2:
                    e_2 = _a.sent();
                    dispatch(exports.fetchPostFailure());
                    throw e_2;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getMyAnnouncementPost = getMyAnnouncementPost;
//@TODO need to post strict return type for this function
var getPostBySlug = function (slug) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchingPost());
                    return [4 /*yield*/, axios_1.default.get("/api/post/slug/" + slug)];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.fetchPostSuccess(data));
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    dispatch(exports.fetchPostFailure());
                    throw e_3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getPostBySlug = getPostBySlug;
var createPost = function (subscription_plan_id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.creatingPost());
                    return [4 /*yield*/, axios_1.default.post('/api/post', {
                            subscription_plan_id: subscription_plan_id,
                        }, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.createPostSuccess(data));
                    return [2 /*return*/, data];
                case 2:
                    e_4 = _a.sent();
                    dispatch(exports.createPostFailure());
                    throw e_4;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.createPost = createPost;
var updatePost = function (id, values) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.creatingPost());
                    return [4 /*yield*/, axios_1.default.put("/api/post/" + id, values, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.createPostSuccess(data));
                    return [2 /*return*/, data];
                case 2:
                    e_5 = _a.sent();
                    dispatch(exports.createPostFailure());
                    dispatch(exports.setPostFailureErrors(e_5));
                    throw e_5;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.updatePost = updatePost;
var addView = function (fingerprint, postId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.post("/api/post/" + postId + "/view", {
                            fingerprint: fingerprint,
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_6 = _a.sent();
                    dispatch(exports.addingPostViewFailure(e_6));
                    throw e_6;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.addView = addView;
var uploadBuildingMedia = function (id, media, buildingMediaType) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var formData_1, data, e_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch(exports.uploadingImages());
                    formData_1 = new FormData();
                    media.forEach(function (file) {
                        formData_1.append('media[]', file);
                        !lodash_1.default.isUndefined(buildingMediaType) &&
                            formData_1.append('buildingMediaType', String(buildingMediaType));
                    });
                    return [4 /*yield*/, axios_1.default.post("/api/post/" + id + "/media-upload", formData_1, {
                            headers: {
                                'content-type': 'multipart/form-data',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.uploadBuildingImagesSuccess(data))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, data.media];
                case 3:
                    e_7 = _a.sent();
                    dispatch(exports.uploadImagesFailure());
                    throw e_7;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.uploadBuildingMedia = uploadBuildingMedia;
var removeParentEntityMediaById = function (id, mediaId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch(exports.uploadingImages());
                    return [4 /*yield*/, axios_1.default.delete("/api/post/" + id + "/delete-parent-entity-media/" + mediaId)];
                case 1:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.uploadBuildingImagesSuccess(data))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, data.media];
                case 3:
                    e_8 = _a.sent();
                    dispatch(exports.uploadImagesFailure());
                    throw e_8;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.removeParentEntityMediaById = removeParentEntityMediaById;
var reorderBuildingMedia = function (id, from, to) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.post("/api/post/" + id + "/media-reorder", { from: from, to: to }, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.uploadBuildingImagesSuccess(data))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, data.media];
                case 3:
                    e_9 = _a.sent();
                    dispatch(exports.uploadImagesFailure());
                    throw e_9;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.reorderBuildingMedia = reorderBuildingMedia;
var uploadApartmentMedia = function (id, aptId, media) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var fd_1, data, e_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(exports.uploadingImages());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    fd_1 = new FormData();
                    media.forEach(function (f) {
                        fd_1.append('media[]', f);
                    });
                    return [4 /*yield*/, axios_1.default.post("/api/post/" + id + "/entity/" + aptId + "/media-upload", fd_1, {
                            headers: {
                                'content-type': 'multipart/form-data',
                            },
                        })];
                case 2:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.uploadApartmentImagesSuccess({ id: aptId, media: data.media }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/, data.media];
                case 4:
                    e_10 = _a.sent();
                    dispatch(exports.uploadImagesFailure());
                    throw e_10;
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
exports.uploadApartmentMedia = uploadApartmentMedia;
var uploadEntityPlanMediaById = function (id, aptId, media, type) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var fd, data, e_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(exports.uploadingImages());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    fd = new FormData();
                    fd.append('media', media);
                    return [4 /*yield*/, axios_1.default.post("/api/post/" + id + "/entity/" + aptId + "/media-plan/" + type, fd, {
                            headers: {
                                'content-type': 'multipart/form-data',
                            },
                        })];
                case 2:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.uploadApartmentImagesSuccess({ id: aptId, media: data.media }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/, data.media];
                case 4:
                    e_11 = _a.sent();
                    dispatch(exports.uploadImagesFailure());
                    throw e_11;
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
exports.uploadEntityPlanMediaById = uploadEntityPlanMediaById;
var removeEntityMediaByID = function (id, aptId, idToRemove) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch(exports.uploadingImages());
                    return [4 /*yield*/, axios_1.default.delete("/api/post/" + id + "/entity/" + aptId + "/" + idToRemove)];
                case 1:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.uploadApartmentImagesSuccess({ id: aptId, media: data.media }))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, data.media];
                case 3:
                    e_12 = _a.sent();
                    dispatch(exports.uploadImagesFailure());
                    throw e_12;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.removeEntityMediaByID = removeEntityMediaByID;
var removeEntityPlanMediaById = function (id, aptId, idToRemove, type) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch(exports.uploadingImages());
                    return [4 /*yield*/, axios_1.default.delete("/api/post/" + id + "/entity/" + aptId + "/media-plan/" + idToRemove)];
                case 1:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.uploadEntityMediaPlanSuccess({ id: aptId, type: type }))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, data.media];
                case 3:
                    e_13 = _a.sent();
                    dispatch(exports.uploadImagesFailure());
                    throw e_13;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.removeEntityPlanMediaById = removeEntityPlanMediaById;
var reorderApartmentMedia = function (id, aptId, from, to) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.post("/api/post/" + id + "/entity/" + aptId + "/media-reorder", { from: from, to: to }, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.uploadApartmentImagesSuccess({ id: aptId, media: data.media }))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, data.media];
                case 3:
                    e_14 = _a.sent();
                    dispatch(exports.uploadImagesFailure());
                    throw e_14;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.reorderApartmentMedia = reorderApartmentMedia;
var addEmptyApartment = function (id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_15;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch(exports.duplicatingApartment());
                    return [4 /*yield*/, axios_1.default.post("/api/post/" + id + "/entity", {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.duplicateApartmentSuccess(data.data))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, data.data];
                case 3:
                    e_15 = _a.sent();
                    dispatch(exports.duplicateApartmentFailure());
                    throw e_15;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.addEmptyApartment = addEmptyApartment;
var duplicateApartment = function (id, aptId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_16;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch(exports.duplicatingApartment());
                    return [4 /*yield*/, axios_1.default.post("/api/post/" + id + "/entity/" + aptId + "/duplicate", {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.duplicateApartmentSuccess(data.data))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, data.data];
                case 3:
                    e_16 = _a.sent();
                    dispatch(exports.duplicateApartmentFailure());
                    throw e_16;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.duplicateApartment = duplicateApartment;
var removeApartment = function (id, aptId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_17;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch(exports.removingApartment());
                    return [4 /*yield*/, axios_1.default.delete("/api/post/" + id + "/entity/" + aptId, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(exports.removeApartmentSuccess(aptId))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_17 = _a.sent();
                    dispatch(exports.removeApartmentFailure());
                    throw e_17;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.removeApartment = removeApartment;
var publishPost = function (id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_18;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.creatingPost());
                    return [4 /*yield*/, axios_1.default.post("/api/post/" + id + "/publish")];
                case 1:
                    _a.sent();
                    dispatch(exports.getPost(id));
                    return [3 /*break*/, 3];
                case 2:
                    e_18 = _a.sent();
                    dispatch(exports.createPostFailure());
                    dispatch(exports.setPostFailureErrors(e_18));
                    throw e_18;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.publishPost = publishPost;
var getPostEntity = function (id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_19;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchPostEntity());
                    return [4 /*yield*/, axios_1.default.get("/api/post/get-entity/" + id)];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.setPostEntityMetas({ entities: data.data, id: id }));
                    dispatch(exports.fetchPostEntitySuccess());
                    return [2 /*return*/, data.data];
                case 2:
                    e_19 = _a.sent();
                    dispatch(exports.fetchPostEntityFailure());
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getPostEntity = getPostEntity;
var updateEntity = function (id, values) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_20;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(exports.fetchUpdatePostEntity());
                    return [4 /*yield*/, axios_1.default.put("/api/post/entity/" + id, __assign({}, values))];
                case 1:
                    _a.sent();
                    dispatch(exports.fetchUpdatePostEntitySuccess());
                    return [3 /*break*/, 3];
                case 2:
                    e_20 = _a.sent();
                    dispatch(exports.fetchUpdatePostEntityFailure());
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.updateEntity = updateEntity;
var getTranslatedText = function (text, toLanguage) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_21;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.post('/api/translate', {
                            text: text,
                            lang: toLanguage,
                        })];
                case 1:
                    data = (_a.sent()).data;
                    dispatch(exports.translationComplete());
                    return [2 /*return*/, data];
                case 2:
                    e_21 = _a.sent();
                    dispatch(exports.translationComplete());
                    throw e_21;
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
exports.getTranslatedText = getTranslatedText;
exports.creatingPost = (_a = postSlice.actions, _a.creatingPost), exports.createPostSuccess = _a.createPostSuccess, exports.createPostFailure = _a.createPostFailure, exports.fetchingPost = _a.fetchingPost, exports.fetchPostSuccess = _a.fetchPostSuccess, exports.fetchPostFailure = _a.fetchPostFailure, exports.addingPostViewFailure = _a.addingPostViewFailure, exports.uploadingImages = _a.uploadingImages, exports.uploadBuildingImagesSuccess = _a.uploadBuildingImagesSuccess, exports.uploadImagesFailure = _a.uploadImagesFailure, exports.uploadApartmentImagesSuccess = _a.uploadApartmentImagesSuccess, exports.duplicatingApartment = _a.duplicatingApartment, exports.duplicateApartmentSuccess = _a.duplicateApartmentSuccess, exports.duplicateApartmentFailure = _a.duplicateApartmentFailure, exports.removingApartment = _a.removingApartment, exports.removeApartmentSuccess = _a.removeApartmentSuccess, exports.removeApartmentFailure = _a.removeApartmentFailure, exports.toggleBookmarked = _a.toggleBookmarked, exports.uploadEntityMediaPlanSuccess = _a.uploadEntityMediaPlanSuccess, exports.fetchPostEntity = _a.fetchPostEntity, exports.fetchPostEntitySuccess = _a.fetchPostEntitySuccess, exports.fetchPostEntityFailure = _a.fetchPostEntityFailure, exports.setPostEntityMetas = _a.setPostEntityMetas, exports.fetchUpdatePostEntity = _a.fetchUpdatePostEntity, exports.fetchUpdatePostEntitySuccess = _a.fetchUpdatePostEntitySuccess, exports.fetchUpdatePostEntityFailure = _a.fetchUpdatePostEntityFailure, exports.setPostFailureErrors = _a.setPostFailureErrors, exports.clearPostFailureErrors = _a.clearPostFailureErrors, exports.clearPostData = _a.clearPostData, exports.translationStart = _a.translationStart, exports.translationComplete = _a.translationComplete;
var selectLoading = function (state) {
    return state.post.loading || schemaSlice_1.selectSchemaLoading(state);
};
exports.selectLoading = selectLoading;
var selectUpdateApartmentLoading = function (state) {
    return state.post.updateApartmentLoading;
};
exports.selectUpdateApartmentLoading = selectUpdateApartmentLoading;
var selectUpdateApartmentSuccess = function (state) {
    return state.post.updateApartmentSuccess;
};
exports.selectUpdateApartmentSuccess = selectUpdateApartmentSuccess;
var selectHasPermission = function (id) { return function (state) {
    var post = exports.selectPost(id)(state);
    return post && state.user.data && post.user.id === state.user.data.id;
}; };
exports.selectHasPermission = selectHasPermission;
var selectPostLoading = function (state) { return state.post.loading; };
exports.selectPostLoading = selectPostLoading;
var selectTranslationSender = function (state) {
    return state.post.translationSender;
};
exports.selectTranslationSender = selectTranslationSender;
var selectPost = function (id) { return function (state) {
    var post = state.post.post;
    return post && post.id === id ? post : undefined;
}; };
exports.selectPost = selectPost;
var selectCurrentPost = function (state) {
    var post = state.post.post;
    return post;
};
exports.selectCurrentPost = selectCurrentPost;
var selectIsTranslating = function (state) {
    return state.post.isTranslating;
};
exports.selectIsTranslating = selectIsTranslating;
function composeInitialValues(sections, common) {
    var fields = sections.reduce(function (acc, section) {
        acc[section.name] = composeSingleSectionInitialValues(section);
        return acc;
    }, {});
    return __assign(__assign({}, fields), { deal: common.deal.value, acceptTerms: false });
}
function composeSingleSectionInitialValues(section) {
    var fields = section.fields, isArray = section.isArray;
    var flattenFields = fields.rows.reduce(function (acc, r) {
        return __assign(__assign({}, acc), r.row_descriptor);
    }, {});
    var value = Object.entries(flattenFields).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], field = _a[1];
        return __assign(__assign({}, acc), (_b = {}, _b[key] = field.value, _b));
    }, {});
    if (isArray) {
        // TODO: Bad assumption, that only apartments have multiple values
        value.media = [];
        value = [value];
    }
    return value;
}
exports.composeSingleSectionInitialValues = composeSingleSectionInitialValues;
var initialValuesFromExisting = function (steps, common, post) {
    var init = composeInitialValues(steps, common);
    if (!post) {
        return init;
    }
    // For sections containing sub-sections, we need to
    // create default values for each existing one and only
    // then merge actual data
    lodash_1.default.each(post.sections, function (s, k) {
        if (lodash_1.default.isArray(s)) {
            var defaults_1 = init[k][0];
            init[k] = lodash_1.default.range(s.length).map(function (i) {
                return lodash_1.default.clone(defaults_1);
            });
        }
    });
    var initialValues = lodash_1.default.merge({}, init, post.sections);
    // Deal initial value
    initialValues.deal = post.deal;
    // Terms agreed initial value
    initialValues.acceptTerms = post.acceptTerms;
    // Contacts initial values
    if (post.contacts.length) {
        initialValues.contact.contacts = post.contacts;
    }
    initialValues.property_info.address_picker = post.location;
    initialValues.removedMortgageIds = [];
    return initialValues;
};
var selectInitialValues = function (id) { return function (state) {
    var sections = schemaSlice_1.selectPostSections(state);
    if (!sections.length || !state.post.post) {
        return;
    }
    return initialValuesFromExisting(sections, schemaSlice_1.selectCommonFields(state), exports.selectPost(id)(state));
}; };
exports.selectInitialValues = selectInitialValues;
var selectSinglePost = function (state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var previewSchema = schemaSlice_1.selectPreviewSchema(state);
    var p = state.post.post;
    if (!p || !previewSchema) {
        return;
    }
    var _x = p.sections, initial_info = _x.initial_info, apartment_info = _x.apartment_info, _y = _x.about_building, about_building = _y === void 0 ? {} : _y;
    return __assign(__assign({}, p), { property_type: initial_info.property_type, sqmPrice: p.priceFull && p.isDeveloper
            ? apartment_info.map(function (apartment) {
                return {
                    price: apartment.sqm_price,
                    currency: apartment.currency,
                };
            })
            : [
                {
                    price: (_b = (_a = apartment_info[0]) === null || _a === void 0 ? void 0 : _a.sqm_price) !== null && _b !== void 0 ? _b : '',
                    currency: (_d = (_c = apartment_info[0]) === null || _c === void 0 ? void 0 : _c.currency) !== null && _d !== void 0 ? _d : '',
                },
            ], deposit: [
            {
                price: (_f = (_e = apartment_info[0]) === null || _e === void 0 ? void 0 : _e.deposit) !== null && _f !== void 0 ? _f : '',
                currency: (_h = (_g = apartment_info[0]) === null || _g === void 0 ? void 0 : _g.currency) !== null && _h !== void 0 ? _h : '',
            },
        ], address: [
            (_j = p.location.addressData) === null || _j === void 0 ? void 0 : _j.state,
            (_k = p.location.addressData) === null || _k === void 0 ? void 0 : _k.district,
            (_l = p.location.addressData) === null || _l === void 0 ? void 0 : _l.address,
        ].filter(function (p) { return p; }), addressData: {
            state: (_m = p.location.addressData) === null || _m === void 0 ? void 0 : _m.state,
            district: (_o = p.location.addressData) === null || _o === void 0 ? void 0 : _o.district,
            address: (_p = p.location.addressData) === null || _p === void 0 ? void 0 : _p.address,
        }, floor: (_r = (_q = apartment_info[0]) === null || _q === void 0 ? void 0 : _q.floor) !== null && _r !== void 0 ? _r : '', building_floors: about_building.building_floors, base_area: (_t = (_s = apartment_info[0]) === null || _s === void 0 ? void 0 : _s.area) !== null && _t !== void 0 ? _t : '', rooms_count: (_v = (_u = apartment_info[0]) === null || _u === void 0 ? void 0 : _u.rooms) !== null && _v !== void 0 ? _v : '', publish_date: p.publishedAt, location: p.location.location, building_apt_amount: about_building.building_apt_amount, building_vacant_apt_amount: about_building.building_vacant_apt_amount, building_name: about_building.building_name, sections: __assign(__assign({}, p.sections), { short_info: {
                contact_phone: (_w = p.contacts[0]) === null || _w === void 0 ? void 0 : _w.phone,
            }, apartment_info: apartment_info.map(function (a) { return (__assign(__assign({}, a), { title: 'PROPERTY_SECTION_ABOUT_APARTMENT', description: a.description, amenities: apartmentAmenities(previewSchema, __assign(__assign({}, a), { structure_type: p.sections.initial_info.structure_type, property_type: p.sections.initial_info.property_type, deal: p.deal })) })); }), house_info: __assign(__assign({}, about_building), { title: 'PROPERTY_SECTION_ABOUT_BUILDING', description: about_building.description || '', amenities: buildingAmenities(previewSchema, __assign(__assign({}, about_building), { structure_type: p.sections.initial_info.structure_type })) }) }) });
};
exports.selectSinglePost = selectSinglePost;
var selectUpdatePostFailureErrors = function (state) {
    return state.post.updatePostFailureErrors;
};
exports.selectUpdatePostFailureErrors = selectUpdatePostFailureErrors;
var selectPersonalMedia = function (id) { return function (state) {
    var p = state.post.post;
    if (!p) {
        return [];
    }
    if (p.id !== id) {
        return [];
    }
    var _a = p.sections, apartment_info = _a.apartment_info, _b = _a.about_building, about_building = _b === void 0 ? {} : _b;
    var tour3D = p.tour3D ? [__assign(__assign({}, p.tour3D), { url: p.tour3D.path })] : [];
    return __spreadArray(__spreadArray(__spreadArray([], tour3D), apartment_info.reduce(function (acc, _a) {
        var media = _a.media;
        return __spreadArray(__spreadArray([], acc), media);
    }, [])), about_building.media);
}; };
exports.selectPersonalMedia = selectPersonalMedia;
var selectDeveloperMedia = function (id, aptId) { return function (state) {
    var p = state.post.post;
    if (!p) {
        return [];
    }
    if (p.id !== id) {
        return [];
    }
    var _a = p.sections, apartment_info = _a.apartment_info, _b = _a.about_building, about_building = _b === void 0 ? {} : _b;
    if (!aptId) {
        var tour3D = p.tour3D
            ? [__assign(__assign({}, p.tour3D), { url: p.tour3D.path })]
            : [];
        return __spreadArray(__spreadArray([], tour3D), about_building.media);
    }
    var _c = apartment_info.find(function (apt) { return apt.entity_id == aptId; }), media = _c.media, floor_plan = _c.floor_plan, apartment_plan = _c.apartment_plan, building_plan = _c.building_plan;
    return __spreadArray(__spreadArray([], media), [floor_plan, apartment_plan, building_plan]).filter(function (m) { return m !== null; });
}; };
exports.selectDeveloperMedia = selectDeveloperMedia;
var apartmentAmenities = function (_a, apt) {
    var apartment_info = _a.apartment_info;
    return lodash_1.default(apartment_info)
        .filter(function (a) {
        var isVisible = schemaHelper_1.checkCondition(a.displayCondition, apt);
        return !a.hidden && isVisible;
    })
        .map(function (_a) {
        var label = _a.label, icon = _a.icon;
        return {
            data: apt[label],
            icon: icon,
            title: "fields.section4." + label,
        };
    })
        .value();
};
var buildingAmenities = function (_a, building) {
    var about_building = _a.about_building;
    return lodash_1.default(about_building)
        .filter(function (b) {
        var isVisible = schemaHelper_1.checkCondition(b.displayCondition, building);
        return !b.hidden && isVisible;
    })
        .map(function (_a) {
        var label = _a.label, icon = _a.icon;
        return {
            data: building[label],
            icon: icon,
            title: "fields.section6." + label,
        };
    })
        .value();
};
exports.default = postSlice.reducer;
